import { useMutation, useQueryClient } from "@tanstack/react-query";
import { includes } from "lodash/fp";

import * as api from "./api";
import { Upload } from "./types";

const useUpload = () => {
  const queryClient = useQueryClient();

  const generateReports = useMutation<Upload[], unknown, { uploads: Upload[] }>(
    {
      mutationFn: api.generateReports,
      onSettled: () => {
        queryClient.refetchQueries({
          predicate: (query) =>
            query.queryKey[0] === "sessionsList" &&
            !includes("search", query.queryKey),
        });
      },
    }
  );
  return {
    generateReports,
  };
};

export default useUpload;
